import {
    RESET_PROMOCODE_DETAILS,
    GET_PROMOCODE_DETAILS,
    GET_PROMOCODES,
    ADD_PROMOCODE
  } from '../actionTypes';
  
  const initialState = {
    promocodes: [],
    promocodeDetails: null,
  };


  const promocodesReducer = (state = initialState, action) => {
    switch (action.type) {
      case RESET_PROMOCODE_DETAILS:
        return {
          ...state,
          promocodeDetails: null
        };
      case GET_PROMOCODES:
      return {
        ...state,
        promocodes: action.payload
      };
    case GET_PROMOCODE_DETAILS:
      return {
        ...state,
        promocodeDetails: action.payload
      };
        case ADD_PROMOCODE:
          return {
            ...state,
            promocodeDetails: action.payload
          };
      default: {
        return state;
      }
    }
  };
  





  export default promocodesReducer;
